/* eslint-disable no-inline-styles/no-inline-styles */
import { Modal, Row, Col, Space, Typography } from 'antd';
import { SimpleButton } from '@components/buttons';
import { ConfirmationModalProps } from './ConfirmationModal.types';
import styles from './ConfirmationModal.module.less';

const { Text } = Typography;

export const ConfirmationModal = ({
  children,
  isModalOpen,
  title = 'Confirmation',
  onYes,
  onNo,
  loadingState,
  yesText = 'Yes',
  noText = 'No',
  yesIcon,
  noIcon,
  destroyOnClose = false,
  keyboard = true,
  className,
  showNo = true,
}: ConfirmationModalProps) => {
  return (
    <Modal
      open={isModalOpen}
      footer={null}
      onCancel={onNo}
      centered
      closable={false}
      maskClosable={false}
      destroyOnClose={destroyOnClose}
      keyboard={keyboard}
      className={className}
    >
      <Row>
        <Col xs={24}>
          <Text className={styles.Title}>{title}</Text>
        </Col>
      </Row>
      {children}
      <Row className={`mt-10`}>
        <Col span={24}>
          <Space>
            {showNo && (
              <SimpleButton outlined onClick={onNo} loading={loadingState} icon={noIcon}>
                {noText}
              </SimpleButton>
            )}

            <SimpleButton onClick={onYes} loading={loadingState} icon={yesIcon}>
              {yesText}
            </SimpleButton>
          </Space>
        </Col>
      </Row>
    </Modal>
  );
};
